import { useNavigate } from "react-router-dom";

const DonateCard = ({
  id,
  title,
  body,
  cardImage,
  targetAmount,
  bgColor,
  amountRaised,
  pageName,
}) => {
  const navigate = useNavigate();

  // const handleNavigate = () => {
  //   dispatch(getProject({ projectId: id })).then(() => {
  //     dispatch(getDonationPerProject({ id }));
  //     let path = `/projects/${id}`;
  //     navigate(path, { state: pageName });
  //   });
  // };

  const handleNavigate = () => {
    let path = `/projects/${id}`;
    navigate(path, { state: pageName });
  };

  const percentage = Math.floor((amountRaised / targetAmount) * 100);

  const width = `w-[${percentage}%]`;

  return (
    <div className="h-[500px] w-[300px] flex flex-col shadow-lg">
      <div className="relative h-[170px]">
        <img
          className="w-full h-full object-cover"
          src={cardImage}
          alt="Kids Learning"
        />
        <div
          className={`absolute right-6 -bottom-3 text-[12px] leading-[14px] p-2 text-white ${bgColor}`}
        >
          DONATE NOW
        </div>
      </div>
      <div className="h-full flex justify-between flex-col p-4">
        <div>
          <div>
            <p className="text-[20px] leading-[23px] capitalize font-bold mt-2 mb-3">
              {title}
            </p>
          </div>
          <div>
            <p className="text-[16px] text-[#7A7A7A] leading-[24px] mb-2">
              {body}
            </p>
          </div>
        </div>
        <div>
          <div className="my-4 flex bg-[#CCCCCC]">
            <div className={`h-[10px] ${bgColor} ${width}`}>
              <p className="text-[8px]">{percentage}%...</p>
            </div>
          </div>
          <div className="flex text-[16px] leading-[16px] mb-4">
            <p className="font-bold mr-1">N{amountRaised}</p>
            <p>raised of N{targetAmount} goal</p>
          </div>
          <div
            onClick={handleNavigate}
            className={`w-2/5 flex justify-center cursor-pointer rounded-full py-2 px-1 text-white text-[12px] whitespace-nowrap hover:font-bold ${bgColor}`}
          >
            <p>View Details</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonateCard;
